import {
    SubmitHandler,
} from 'react-hook-form'


export interface RegisterViewProps {
    isConnecting: boolean;
    onSubmitFormData: SubmitHandler<RegisterFormInputs>;
    signupAsGuest: SubmitHandler<RegisterFormInputs>;
    error?: string;
    funnelView: FunnelViewType;
    hasRegisterError: (error?: string) => boolean;
}

export type FunnelViewType = 'email' | 'password' | 'username' | 'completed'
export enum SelectedItem {
    Register,
    Login
}

export type RegisterFormInputs = {
    userName: string;
    email: string;
    password: string;
    realName?: string;
}

export type SsoProps = {
    email?: string
    name?: string
}
